import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/store/reducers";
import { useGetEventsMutation } from "../../api/event";
import { Event } from "./Event";

export const Events = ({ getUserPost }: { getUserPost?: boolean }) => {
  const eventList = useSelector((state: RootState) => state.event.events);
  const [getEvents] = useGetEventsMutation();

  useEffect(() => {
    getEvents({
      getUserEvent: getUserPost,
    });
  }, [getUserPost]);

  return (
    <div className="pl-[100px] pr-[100px]">
      {eventList.map((event) => (
        <Event eventDetail={event} key={event.postId} />
      ))}
    </div>
  );
};
